"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.getTransactions = exports.getServerInfo = exports.getAccountInfo = exports.submit = exports.preparePayment = exports.formatAPICurrencyXRP = exports.parseAPICurrencyObject = exports.parseAPIValue = exports.disconnect = exports.connectionTimeout = void 0;
var bignumber_js_1 = require("bignumber.js");
var currencies_1 = require("../currencies");
var env_1 = require("../env");
var ripple_lib_1 = require("ripple-lib");
var rippleUnit = (0, currencies_1.getCryptoCurrencyById)("ripple").units[0];
var defaultEndpoint = function () { return (0, env_1.getEnv)("API_RIPPLE_WS"); };
exports.connectionTimeout = 30 * 1000; // default connectionTimeout is 2s and make the specs bot failed
var WEBSOCKET_DEBOUNCE_DELAY = 30000;
var api;
var pendingQueries = [];
var apiDisconnectTimeout;
/**
 * Connects to Substrate Node, executes calls then disconnects
 *
 * @param {*} execute - the calls to execute on api
 */
function withApi(execute, endpointConfig) {
    if (endpointConfig === void 0) { endpointConfig = null; }
    return __awaiter(this, void 0, void 0, function () {
        var server, err_1, query, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    server = endpointConfig || defaultEndpoint();
                    if (!api) return [3 /*break*/, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, api.isConnected];
                case 2:
                    if (!(_a.sent())) {
                        throw new Error("XRP WS is not connected");
                    }
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    // definitely not connected...
                    api = null;
                    pendingQueries = [];
                    return [3 /*break*/, 4];
                case 4:
                    if (!!api) return [3 /*break*/, 6];
                    api = new ripple_lib_1.RippleAPI({
                        server: server
                    });
                    // https://github.com/ripple/ripple-lib/issues/1196#issuecomment-583156895
                    // We can't add connectionTimeout to the constructor
                    // We need to add this config to allow the bot to not timeout on github action
                    // but it will throw a 'additionalProperty "connectionTimeout" exists'
                    // during the preparePayment
                    api.connection._config.connectionTimeout = exports.connectionTimeout;
                    api.on("error", function (errorCode, errorMessage) {
                        console.warn("Ripple API error: ".concat(errorCode, ": ").concat(errorMessage));
                    });
                    return [4 /*yield*/, api.connect()];
                case 5:
                    _a.sent();
                    _a.label = 6;
                case 6:
                    cancelDebouncedDisconnect();
                    _a.label = 7;
                case 7:
                    _a.trys.push([7, , 9, 10]);
                    query = execute(api);
                    pendingQueries.push(query["catch"](function (err) { return err; }));
                    return [4 /*yield*/, query];
                case 8:
                    res = _a.sent();
                    return [2 /*return*/, res];
                case 9:
                    debouncedDisconnect();
                    return [7 /*endfinally*/];
                case 10: return [2 /*return*/];
            }
        });
    });
}
/**
 * Disconnects Websocket API client after all pending queries are flushed.
 */
var disconnect = function () { return __awaiter(void 0, void 0, void 0, function () {
    var disconnecting, pending_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                cancelDebouncedDisconnect();
                if (!api) return [3 /*break*/, 3];
                disconnecting = api;
                pending_1 = pendingQueries;
                api = undefined;
                pendingQueries = [];
                return [4 /*yield*/, Promise.all(pending_1)];
            case 1:
                _a.sent();
                return [4 /*yield*/, disconnecting.disconnect()];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.disconnect = disconnect;
var cancelDebouncedDisconnect = function () {
    if (apiDisconnectTimeout) {
        clearTimeout(apiDisconnectTimeout);
        apiDisconnectTimeout = null;
    }
};
/**
 * Disconnects Websocket client after a delay.
 */
var debouncedDisconnect = function () {
    cancelDebouncedDisconnect();
    apiDisconnectTimeout = setTimeout(exports.disconnect, WEBSOCKET_DEBOUNCE_DELAY);
};
var parseAPIValue = function (value) {
    return (0, currencies_1.parseCurrencyUnit)(rippleUnit, value);
};
exports.parseAPIValue = parseAPIValue;
var parseAPICurrencyObject = function (_a) {
    var currency = _a.currency, value = _a.value;
    if (currency !== "XRP") {
        console.warn("RippleJS: attempt to parse unknown currency ".concat(currency));
        return new bignumber_js_1.BigNumber(0);
    }
    return (0, exports.parseAPIValue)(value);
};
exports.parseAPICurrencyObject = parseAPICurrencyObject;
var formatAPICurrencyXRP = function (amount) {
    var value = (0, currencies_1.formatCurrencyUnit)(rippleUnit, amount, {
        showAllDigits: true,
        disableRounding: true,
        useGrouping: false
    });
    return {
        currency: "XRP",
        value: value
    };
};
exports.formatAPICurrencyXRP = formatAPICurrencyXRP;
var preparePayment = function (address, payment, instruction) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, withApi(function (api) { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, api.preparePayment(address, payment, instruction)];
                });
            }); })];
    });
}); };
exports.preparePayment = preparePayment;
var submit = function (signature) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, withApi(function (api) { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, api.request("submit", {
                            tx_blob: signature
                        })];
                });
            }); })];
    });
}); };
exports.submit = submit;
// endpointConfig does not seem to be undestood by linter
var getAccountInfo = function (recipient, 
// eslint-disable-next-line @typescript-eslint/no-unused-vars
endpointConfig) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, withApi(function (api) { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, api.getAccountInfo(recipient)];
                });
            }); })];
    });
}); };
exports.getAccountInfo = getAccountInfo;
var getServerInfo = function (
// eslint-disable-next-line @typescript-eslint/no-unused-vars
endpointConfig) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, withApi(function (api) { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, api.getServerInfo()];
                });
            }); })];
    });
}); };
exports.getServerInfo = getServerInfo;
/* eslint-enable no-unused-vars */
var getTransactions = function (address, options) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, withApi(function (api) { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, api.getTransactions(address, options)];
                });
            }); })];
    });
}); };
exports.getTransactions = getTransactions;
//# sourceMappingURL=Ripple.js.map